import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";
import "firebase/database";

export const config = {
  apiKey: "AIzaSyC_DeXTNCJCOSaLzhL-GytF2Vn5KinOiWk",
  authDomain: "gamification-dww.firebaseapp.com",
  databaseURL: "https://gamification-dww.firebaseio.com",
  projectId: "gamification-dww",
  storageBucket: "gamification-dww.appspot.com",
  messagingSenderId: "614148145938",
  appId: "1:614148145938:web:2ef6c3e0cea2c5425369cb",
  measurementId: "G-QBJ6Y58P85",
};

export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;
  const userRef = firestore.doc(`users/${userAuth.uid}`);
  const snapShot = await userRef.get();

  if (!snapShot.exists) {
    const { displayName, email } = userAuth;
    console.log(userAuth);
    const createdAt = new Date();
    try {
      await userRef.set({
        displayName,
        email,
        createdAt,
        ...additionalData,
      });
    } catch (error) {
      console.log("Error creating  user", error.message);
    }
  }
  return userRef;
};

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      unsubscribe();
      resolve(userAuth);
    }, reject);
  });
};

firebase.initializeApp(config);
const adminFirebase = firebase.initializeApp(config, "admin");
export const adminAuth = adminFirebase.auth();
export const auth = firebase.auth();
export const functions = firebase.functions();
export const firestore = firebase.firestore();
if (false) {
  firestore.settings({
    host: "localhost:8080",
    ssl: false,
  });
}
export const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });
//export const signInWithGoogle = () => auth.signInWithPopup(googleProvider);
export default firebase;
